<div class="bg-white border rounded p-3 mb-3">
  <h6 class="mb-2">Person Search</h6>
  <div class="row g-2 align-items-end mb-2">
    <div class="col-auto">
      <label class="form-label" for="searchFirst">First Name</label>
      <input
        id="searchFirst"
        type="text"
        class="form-control"
        placeholder="First name"
        [(ngModel)]="firstName"
        name="searchFirst"
      />
    </div>
    <div class="col-auto">
      <label class="form-label" for="searchLast">Last Name</label>
      <input
        id="searchLast"
        type="text"
        class="form-control"
        placeholder="Last name"
        [(ngModel)]="lastName"
        name="searchLast"
      />
    </div>
    <div class="col-auto">
      <label class="form-label" for="searchEin">EIN</label>
      <input id="searchEin" type="text" class="form-control" placeholder="EIN" [(ngModel)]="ein" name="searchEin" />
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-primary" (click)="onSearch()">Search</button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-danger" (click)="onClear()">Clear</button>
    </div>
    @if (isEppPortal) {
      <div class="col-auto d-flex align-items-center">
        <div class="form-check form-switch ms-1 mb-1 pb-1">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="searchAllPersons"
            [(ngModel)]="searchAllPersons"
          />
          <label class="form-check-label" for="searchAllPersons">Search All Persons</label>
        </div>
      </div>
    }
  </div>

  <div class="row g-2 align-items-end mb-2 pt-2">
    <div class="col">
      <label class="form-label" for="bulkEin">
        Bulk EIN Lookup (comma-separated)
        <i
          class="info-icon ms-2"
          certTooltip="Use the Format button to the right to convert a list of EINs to a valid format"
        ></i>
      </label>
      <input
        id="bulkEin"
        type="text"
        class="form-control"
        placeholder="1000001, 1000002, 1000003"
        [(ngModel)]="bulkEinInput"
        name="bulkEin"
      />
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-outline-secondary"
        title="Open formatter to convert multi-line list to comma-separated"
        (click)="openBulkFormatterModal()"
      >
        Format
      </button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-primary" (click)="onBulkSearch()">Search</button>
    </div>
    <div class="col-auto">
      <span
        [certTooltip]="searchComplete ? 'No matches to add' : 'Search for persons first'"
        [enableTooltip]="results.length === 0 && !searching"
      >
        <button class="btn btn-primary" (click)="onAddAll()" [disabled]="results.length === 0">Add All Matches</button>
      </span>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-danger" (click)="onBulkClear()">Clear</button>
    </div>
  </div>

  @if (searchPerformed && !searchComplete) {
    <p class="text-primary mt-4 mb-0">Searching...</p>
  } @else if (searchComplete && results.length === 0 && unmatchedEins.length === 0) {
    <p class="text-danger mt-4 mb-0">No matches were found.</p>
  }

  @if (results.length > 0) {
    <div style="max-height: 370px; overflow-y: auto">
      <table class="table table-sm mt-3 mb-0">
        <thead class="sticky-top bg-white">
          <tr>
            <th style="width: 5%; white-space: nowrap" scope="col"></th>
            <th style="width: 5%; white-space: nowrap" scope="col">EIN</th>
            <th style="width: 25%; white-space: nowrap" scope="col">Name</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          @for (person of results; track person.personId) {
            <tr class="align-middle">
              <td style="white-space: nowrap">
                @if (isSelected(person.personId)) {
                  <button class="btn btn-secondary btn-sm" disabled>Added</button>
                } @else {
                  <button class="btn btn-primary btn-sm" (click)="select.emit(person)">Select</button>
                }
              </td>
              <td style="white-space: nowrap">{{ person.ein }}</td>
              <td>{{ person.firstName }} {{ person.lastName }}</td>
              <td>
                @if (isSelected(person.personId)) {
                  <button class="btn btn-danger btn-sm" (click)="remove.emit(person.personId)">Remove</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (unmatchedEins.length > 0) {
    <div class="alert alert-warning mt-3 mb-0">
      <strong>No matches found for:</strong> {{ unmatchedEins.join(', ') }}
    </div>
  }
</div>
